import { render, staticRenderFns } from "./customModal.vue?vue&type=template&id=faa46800&scoped=true"
import script from "./customModal.vue?vue&type=script&lang=js"
export * from "./customModal.vue?vue&type=script&lang=js"
import style0 from "./customModal.vue?vue&type=style&index=0&id=faa46800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa46800",
  null
  
)

export default component.exports